
import { Component, Vue } from "vue-property-decorator";
import CustomBtn from "@/components/CustomBtn.vue";
import { readNfcData, scanNfc } from "@/services/nfc";

declare var NDEFReader: any;

@Component({
  components: { CustomBtn },
})
export default class NFCTestPage extends Vue {
  private nDEFReaderInWindow: boolean = false;
  private abortController: any;
  private scanning: boolean = false;
  private nfcDataDecoded: { records: any[] } = { records: [] };
  private error: string = "";

  private async mounted(): Promise<void> {
    if ("NDEFReader" in window) {
      this.nDEFReaderInWindow = true;
    } else {
      this.nDEFReaderInWindow = false;
    }
  }

  private async scanTag() {
    if (this.nDEFReaderInWindow) {
      this.scanning = true;
      this.abortController = new AbortController();
      try {
        const nfcData = await scanNfc(this.abortController);
        this.nfcDataDecoded = readNfcData(nfcData);
      } catch (e) {
        if (typeof e === "string") {
          this.error = e;
        } else {
          this.error = JSON.stringify(e);
        }
      }
      this.scanning = false;
    }
  }

  private abortScan() {
    this.abortController.abort();
    this.scanning = false;
  }

  private reset() {
    this.nfcDataDecoded = { records: [] };
    this.error = "";

  }

  private async copyToClipboard(text: any) {
    try {
      if (typeof text === "string") {
        await navigator.clipboard.writeText(text);
      } else {
        await navigator.clipboard.writeText(JSON.stringify(text));
      }
      alert("Copied to clipboard");
    } catch (err) {
      // console.error("Could not copy text: ", err);
    }
  }

}
